'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Alarm = require('../model/Alarm');

var _Alarm2 = _interopRequireDefault(_Alarm);

var _ApiError = require('./ApiError');

var _ApiError2 = _interopRequireDefault(_ApiError);

var _Env = require('../util/Env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlarmApi = function () {
  function AlarmApi(dom, storage, events) {
    _classCallCheck(this, AlarmApi);

    this.dom = dom;
    this.storage = storage;
    this.events = events;
  }

  _createClass(AlarmApi, [{
    key: 'getAlarms',
    value: function getAlarms(appName, callback) {
      var dom = this.dom,
          storage = this.storage,
          events = this.events;

      var httpRequest = this.getHttpRequest();

      if (!httpRequest) {
        throw "Could not create XMLHttpRequest. Browser may not support AJAX.";
      }

      var url = this.getUrl(appName);

      var requestHandler = function requestHandler() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            try {
              var result = JSON.parse(httpRequest.responseText);

              var alarms = [];
              if (Array.isArray(result)) {
                alarms = result.map(function (alarmData) {
                  return new _Alarm2.default(alarmData, dom, storage, events);
                });
              }

              callback(alarms, null);
            } catch (e) {
              callback(null, new _ApiError2.default(httpRequest, e));
            }
            return;
          } else {
            callback(null, new _ApiError2.default(httpRequest));
          }
        }
      };

      httpRequest.onreadystatechange = requestHandler;
      httpRequest.open('GET', url);
      httpRequest.send();

      return true;
    }

    /**
     * @VisibleForTesting
     */

  }, {
    key: 'getHttpRequest',
    value: function getHttpRequest() {
      return new XMLHttpRequest();
    }
  }, {
    key: 'getUrl',
    value: function getUrl(appName) {
      var qa = (0, _Env.isQa)() ? 'qa' : '';
      var lang = window.I18n && window.I18n.langEnabled ? window.I18n.lang : 'en';
      var portalIdArray = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.exec(document.location.pathname);
      var maybePortalIdParam = portalIdArray && portalIdArray.length > 1 ? '?portalId=' + portalIdArray[1] + '&lang=' + lang : '?lang=' + lang;
      return 'https://api.hubspot' + qa + '.com/firealarm/v2/alarm/' + appName + maybePortalIdParam;
    }
  }]);

  return AlarmApi;
}();

exports.default = AlarmApi;
module.exports = exports['default'];